<template>
    <div class="home-title">
        <div class="content">
            <div class="left">
                <h4>{{ title }}</h4>
                <span v-if="type === 1" class="icon-cmpt"></span>
                <span v-else-if="type === 2" class="icon-special"></span>
                <span class="icon-bias"></span>
            </div>
            <div class="right" v-if="moreUrl">
                <a :href="moreUrl">查看更多 <span class="icon-more"></span></a>
            </div>
        </div>
        <div class="line"></div>
    </div>
</template>

<script>
export default {
    props: {
        title: { default: '精选赛题', type: String },
        type: { default: 0, type: Number }, // 1 精選賽題 2 熱門賽事
        moreUrl: { default: '', type: String },
    },
};
</script>

<style lang="scss" scoped>
.home-title {
    width: 678px;
    margin: 0 26px;
    padding-top: 2px;
    .content {
        display: flex;
        justify-content: space-between;
        .left {
            display: flex;
            h4 {
                margin: 0;
                margin: 12px 0;
                font-size: 36px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #232526;
                margin-right: 10px;
            }
            .icon-cmpt {
                display: inline-block;
                width: 64px;
                height: 32px;
                background: url('../../assets/home/sift@2x.png') no-repeat center center;
                background-size: 64px 32px;
                transform: translateY(24px);
                margin-right: 10px;
            }
            .icon-special {
                display: inline-block;
                width: 64px;
                height: 32px;
                background: url('../../assets/home/hot@2x.png') no-repeat center center;
                background-size: 64px 32px;
                transform: translateY(24px);
                margin-right: 10px;
            }
            .icon-bias {
                display: inline-block;
                width: 100px;
                height: 12px;
                background: url('../../assets/home/bias@2x.png') no-repeat center center;
                background-size: 100px 12px;
                transform: translateY(40px);
            }
        }
        .right {
            padding-top: 20px;
            transform: translateX(-8px);
            .icon-more {
                display: inline-block;
                height: 24px;
                width: 24px;
                background: url('../../assets/home/right@2x.png') no-repeat center center;
                background-size: 24px;
                transform: translateY(3px);
            }
            a {
                font-size: 22px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #585e66;
            }
        }
    }
    .line {
        width: 678px;
        height: 2px;
        background: url('../../assets/home/dotted@2x.png') no-repeat center center;
        background-size: 678px 2px;
    }
}
</style>
